import {
  isUserAdmin,
  isUserProvider,
  OrderStatusFilters,
} from "@jasper/shared";
import {
  IconInbox,
  IconListDetails,
  IconPlayerPause,
  IconTruckDelivery,
} from "@tabler/icons-react";
import { UseAuth } from "/@/contexts";
import { OrderStatus } from "../../generated/graphql";
import { NavLink } from "./NavLink";
import { asUser } from "./helpers/navMenu";
import { useStatusFilters } from "./hooks/useStatusFilters";
import { getProviderStatusLinks } from "./helpers/navbarLinks";

interface Props {
  newCases: number;
}

export const OrderStatusMenu = ({ newCases }: Props) => {
  const { user } = UseAuth();
  const {
    isSingleStatus,
    isAllActive,
    isInboxActive,
    isToShipActive,
    handleStatusFilterChange,
  } = useStatusFilters();

  const isAdmin = isUserAdmin(asUser(user));
  const isProvider = isUserProvider(asUser(user));

  return (
    <>
      {(isAdmin || isProvider) && <hr style={{ width: "100%" }} />}
      {isAdmin && (
        <>
          <NavLink
            title="INBOX/NEW CASES"
            onClick={() => handleStatusFilterChange(OrderStatusFilters.INBOX)}
            active={isInboxActive}
            notificationNumber={newCases}
            icon={<IconInbox />}
          />
          <NavLink
            title={OrderStatusFilters.ALL}
            onClick={() => handleStatusFilterChange(OrderStatusFilters.ALL)}
            active={isAllActive}
            icon={<IconListDetails />}
          />
          <NavLink
            title={OrderStatus.OnHold}
            onClick={() => handleStatusFilterChange(OrderStatus.OnHold)}
            active={isSingleStatus(OrderStatus.OnHold)}
            icon={<IconPlayerPause />}
          />
          <NavLink
            title="SUPPLIERS MUST SHIP"
            onClick={() => handleStatusFilterChange(OrderStatusFilters.TO_SHIP)}
            active={isToShipActive}
            icon={<IconTruckDelivery />}
          />
        </>
      )}
      {isProvider && (
        <>
          {getProviderStatusLinks(newCases).map(link => (
            <NavLink
              key={link.status}
              title={link.title}
              onClick={() => handleStatusFilterChange(link.status)}
              active={isSingleStatus(link.status)}
              notificationNumber={link.notificationNumber}
              icon={link.icon}
            />
          ))}
          <NavLink
            title={OrderStatusFilters.TO_SHIP}
            onClick={() => handleStatusFilterChange(OrderStatusFilters.TO_SHIP)}
            active={isToShipActive}
            icon={<IconTruckDelivery />}
          />
          <NavLink
            title={OrderStatusFilters.ALL}
            onClick={() => handleStatusFilterChange(OrderStatusFilters.ALL)}
            active={isAllActive}
            icon={<IconListDetails />}
          />
        </>
      )}
    </>
  );
};
